<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-6"><h5>Contatos</h5></div>
            </div>
          </div>
          <div class="card-body">
            <table class="table table-hover">
              <thead>
                <tr style="background-color: rgb(56, 56, 56)">
                  <th scope="col">Código</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Status</th>
                  <th scope="col">Nome</th>
                  <th scope="col">Whatsapp</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="contato in state.contatos"
                  :key="contato.id"
                  :value="contato.id"
                >
                  <td scope="row">{{ contato.id }}</td>
                  <td>{{ contato.tipo }}</td>
                  <td>{{ contato.status }}</td>
                  <td>{{ contato.nome }}</td>
                  <td>{{ contato.whatsapp }}</td>
                  <td>
                    <router-link
                      :to="{
                        name: 'VisualizarContato',
                        params: { id: contato.id },
                      }"
                    >
                      <button
                        title="Visualizar"
                        type="button"
                        class="btn btn-primary"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-eye"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"
                          />
                          <path
                            d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                          />
                        </svg>
                      </button>
                    </router-link>
                    <button
                      @click="deletarContato(contato.id)"
                      title="Deletar"
                      type="button"
                      class="btn btn-danger"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-trash-fill"
                        viewBox="0 0 16 16"
                      >
                        <path
                          d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                        />
                      </svg>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      contatos: [],
    });
    onMounted(() => {
      fetchContatos();
    });
    async function fetchContatos() {
      try {
        const { data } = await services.contato.getAll({ token });
        console.log(data);
        state.contatos = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarContato(id) {
      if (confirm("Deseja deletar esse contato?")) {
        try {
          state.isLoading = true;
          const { data } = await services.contato.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar contato!!!.");
          } else {
            fetchContatos();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarContato,
    };
  },
};
</script>
<style scoped>
h5 {
  color: #000;
}
tr {
  text-align: center;
}
th {
  color: #fff;
  border-bottom: solid 2px #000 !important;
}
td {
  border-bottom: solid 1px #000 !important;
  color: #000;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}
#btn_new_user {
  color: #000;
  font-weight: 600;
  padding: 5px;
  border: solid 2px #000;
  border-radius: 5px;
  background-color: rgb(152, 152, 152);
  transition: 0.2s;
}
#btn_new_user:hover {
  background-color: rgb(210, 209, 209);
}
.table-hover > tbody > tr:hover > * {
  color: rgb(0, 0, 0);
  background-color: rgb(225, 225, 225);
}
</style>
